export default __webpack_public_path__ + "static/media/mximg6.35af3107.webp";